import { ScreeningPscInspection } from "../../types/Screening";

export const ScreeningPscPortBody = (item: ScreeningPscInspection) => {
   return (
        <div className="justify-content-start">
            <div>
                <p>{item.port}</p>
                <small>{item.country !== "Unknown" ? item.country : ""}</small>
            </div>
        </div>
    );
};
